import { Component } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { MessageService } from 'primeng/api';
import { SuperAdministrateur } from 'src/app/shared/models/superadmin';
import { AuthService } from 'src/app/shared/service/auth/auth.service';
import { FecthDataService } from 'src/app/shared/service/fetchservice/fetchservice';
import { ParameterService } from 'src/app/shared/service/params/param';
import { LocalStorageService } from 'src/app/shared/service/storage/localstorage.service';

@Component({
  selector: 'app-update-superadmin',
  standalone: false,
  templateUrl: './update-superadmin.component.html',
  styleUrl: './update-superadmin.component.scss'
})

export class UpdateSuperadminComponent {

  constructor(
    private modalService: NgbModal,
    private messageService: MessageService,
    private authService: AuthService,
    private fecthDataService: FecthDataService,
    private ngxService: NgxUiLoaderService,
    private localStorage: LocalStorageService,
    private paramService: ParameterService,

  ) { }

  item: SuperAdministrateur = new SuperAdministrateur();
  items: any = [];

  paysItems: any = [];
  villeItems: any = [];
  arrondissementItems: any = [];
  cooperativeItems: any = [];


  ngOnInit() {
    this.items = this.localStorage.getAdministrateur();
    console.log("this.items", this.items);
    this.item.nom = this.items.nom;
    this.item.prenom = this.items.prenom;
    this.item.telephone = this.items.telephone;
    this.item.email = this.items.email;
    this.item.sexe = this.items.sexe;
    this.getPays();
  }
  updateAdministrateur() {

    // if (!this.item.canSave()) {

    //   this.messageService.add({ severity: 'info', summary: "AFRICEREAL", detail: this.item.getErrorMessage() });

    // }
    // else if (this.item.canSave()) {
      this.item.pays_id = this.item.pays_id.id;
      this.item.admin_id=this.items.reference;
      this.item.ville_id = this.item.ville_id.id;
      this.ngxService.start();
      this.authService.updateSuperAdministrateur(this.item).subscribe(
        (response: any) => {
          //console.log("la reponse du webservice",response);
          this.messageService.add({ severity: 'success', summary: "AFRICEREAL", detail: response.message });

          this.fecthDataService.notifySeriviceCreated();
          this.modalService.dismissAll();

          this.ngxService.stop();

        },
        (error: any) => {
          //console.log("une erreur est survenu",error);
          // this.modalService.dismissAll()
          this.messageService.add({ severity: 'error', summary: "AFRICEREAL", detail: error });
          this.ngxService.stop();

        }
      )
    // }


  }
  getPays() {
    this.paramService.getPays().subscribe(

      (response: any) => {
        this.paysItems = response.data;
        this.item.pays_id = this.paysItems.find((item: any) => item.id === this.items.ville.country.id);
        this.getvilleByPays(this.items.ville.country.id)
        console.log("this.paysItems", this.paysItems);
      },
      (error) => {
        console.log("une erreur est survenu", error);

      }

    );
  }

  getvilleByPays(departementId: number) {
    this.paramService.getVilleById(departementId).subscribe(
      (response: any) => {
        this.villeItems = response.data;
        this.item.ville_id = this.villeItems.find(
          (item: any) => item.id === this.items.ville.id
        );
        console.log("Liste des communes pour le département", departementId, ":", this.villeItems);
      },
      (error) => {
        console.error("Erreur lors de la récupération des communes :", error);
      }
    );
  }
  getArrondissementByCommune(communeId: number) {
    this.paramService.getArrondissementsByCommune(communeId).subscribe(
      (response: any) => {
        this.arrondissementItems = response.data;
        console.log("Liste des arrondissements pour la commune", communeId, ":", this.arrondissementItems);
      },
      (error) => {
        console.error("Erreur lors de la récupération des arrondissements :", error);
      }
    );
  }


  close() {

    this.modalService.dismissAll();
  }


}